
import { RevButton } from '@ds/components/Button'

import translations from './SwapIntro.translations'

const ESTIMATE = 'toEstimate'
const CLOSE = 'closeIntro'

export default {
  components: {
    RevButton,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    price: {
      type: String,
      required: true,
    },
    closeWording: {
      type: String,
      required: true,
    },
  },
  computed: {
    translations: () => translations,
  },
  methods: {
    discardSwap() {
      this.choose({ to: 'close' }, CLOSE)
    },
    choose(choice, type) {
      this.emitDataLayer({ type })
      this.$emit('completed', choice)
    },
    emitDataLayer({ type = ESTIMATE } = {}) {
      this.$emit('tracking', { type })
    },
  },
}
